var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadedFileGov(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EAE7E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 11.333H13.9998C13.6462 11.333 13.3071 11.4735 13.057 11.7235C12.807 11.9736 12.6665 12.3127 12.6665 12.6663V23.333C12.6665 23.6866 12.807 24.0258 13.057 24.2758C13.3071 24.5259 13.6462 24.6663 13.9998 24.6663H21.9998C22.3535 24.6663 22.6926 24.5259 22.9426 24.2758C23.1927 24.0258 23.3332 23.6866 23.3332 23.333V15.9997M18.6665 11.333L23.3332 15.9997M18.6665 11.333V15.9997H23.3332",
    stroke: "#725798",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#F5F3F2",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedFileGov);
export default __webpack_public_path__ + "static/media/uploaded-file-gov.61dc72001824628ac314a50d0725d820.svg";
export { ForwardRef as ReactComponent };